import PropTypes from 'prop-types';
import withLoaderProvider from "./withLoaderProvider";
var LoaderProvider = function LoaderProvider(_ref) {
  var children = _ref.children;
  return children;
};
LoaderProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default withLoaderProvider(LoaderProvider);